import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const classifyQuickWin = api(async function classifyQuickWin({ tags, additionalTags, dimensions } = {}) {
    return query(
        gql`
            query Query($tags: [String], $additionalTags: [String], $dimensions: Int) {
                classifyQuickWin(tags: $tags, additionalTags: $additionalTags, dimensions: $dimensions) {
                    key
                    status
                    summary
                    possibleCategories {
                        match
                        stats
                        closeness
                    }
                }
            }
        `,
        { tags, additionalTags, dimensions },
        { returns: "classifyQuickWin" }
    )
})
